import { IAction, KEEP_THE_SAME, StateStatus } from 'redux/utils/common';
import { IProductDetails, ISimilarProducts } from 'services/api/product';
import * as Types from './types';
import _ from 'lodash';
export interface IState {
  productDetails: {
    status: StateStatus | null;
    data: IProductDetails[];
  };
  dataId: string[];
  selectedType: string[];
  documentSelected: any[];
  isSavePdf: boolean;
  documents: {
    status: StateStatus | null;
    data: Array<any>;
  };
}

const initialState: IState = {
  productDetails: {
    status: null,
    data: [],
  },
  dataId: [],
  selectedType: [],
  documentSelected: [],
  isSavePdf: false,
  documents: {
    status: null,
    data: [],
  },
};

const ProductPrinPdfReducer = (
  state: IState = initialState,
  action: IAction
): IState => {
  switch (action.type) {
    case Types.SET_PRODUCT_DETAILS:
      return {
        ...state,
        productDetails: {
          ...state.productDetails,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? [...state.productDetails.data]
              : _.uniqBy(
                  [...state.productDetails.data, action.data],
                  (item) => item?.['id']
                ),
        },
      };
    case Types.SET_PRODUCT_DOCUMENT:
      return {
        ...state,
        documents: {
          ...state.documents,
          status: action.status || null,
          data:
            action.data === KEEP_THE_SAME
              ? [...state.documents.data]
              : _.uniqBy(
                  [...state.documents.data, ...action.data],
                  (item) => item?.['id']
                ),
        },
      };
    case Types.SETUP_PRINT:
      return {
        ...state,
        dataId: action.data?.dataId,
        selectedType: action.data?.selectedType,
        documentSelected: action.data?.documentSelected,
        isSavePdf: action.data?.isSavePdf,
      };
    case Types.RESET_STORE:
      return {
        ...state,
        productDetails: {
          status: null,
          data: [],
        },
      };
    case Types.RESET_PRINT:
      return {
        ...state,
        dataId: [],
        selectedType: [],
        documentSelected: [],
        documents: {
          status: null,
          data: [],
        },
      };

    default:
      return {
        ...state,
      };
  }
};

export default ProductPrinPdfReducer;
